<template>
  <div class="page1">

      <div style="
      margin: auto;
      width: 1200px;
      height: 109px;
          z-index: 1000">
        <div style="color: #FFFFFF; font-size: 30px;font-family: 微软雅黑; font-weight: bold ;padding-top:35px">{{
            this.systemName
          }}
        </div>
      </div>
      <div style="width:100%;background-color: #004e96; height: 65px">
        <div
          style=" font-weight: bold;width: 1200px;margin: auto"
        >
          <navigation-bar :default-active="'映射视图'"/>
        </div>
      </div>
    <div style="width: 1200px;margin: auto;">
    <el-row style="margin-top: 10px" v-if="showSystem">
      <el-col>
        <el-tabs style=" min-height:500px;border-right: none" v-model="tabs" tabPosition="left">
          <el-tab-pane label="标准体系" name="1">
        <el-row style="background-color: #FFFFFF;width: 1030px;min-height: 500px;">
          <el-row v-if="biaozhuntixi" style="text-align:center">
            <el-col style="margin:40px auto 0px auto " >
              <span style="font-size: 16px;font-family: SourceHanSansCN-Regular">暂无数据</span>
            </el-col>
          </el-row>
          <el-col style="width: 336px" v-for="system in pageSystem.list" :key="system.id">
            <el-card style="margin-top: 20px;margin-left: 20px">
              <div slot="header" class="clearfix" style="width: 100%">
                <el-button class="white" style="font-size: 16px;color: #045fb4;font-family: SourceHanSansCN-Regular" type="text" @click="openDetail(system.id)">{{ system.name }}</el-button>
              </div>
              <div style="width: 100%">
                <div class="white">
                  <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">体系编码：</span>
                  <template >
                    <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">{{ system.code }}</span>
                  </template>
                </div>
                <div style="margin-top: 10px">
                  <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">发布时间：</span>
                  <template >
                    <span class="white" style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">{{ system.createTime.substring(0,10) }}</span>
                  </template>
                </div>
                <div style="margin-top: 10px">
                  <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">体系状态：</span>
                  <template >
                    <el-tag v-if="system.status=='1'" type="success">启用</el-tag>
                    <el-tag v-if="system.status=='0'" type="warning">停用</el-tag>
                  </template>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>

          </el-tab-pane>
<!--          <el-tab-pane label="政策体系" name="2">
            <el-row style="background-color: #FFFFFF;width: 1030px;min-height: 500px;">
              <el-row v-if="zhengcetixi" style="text-align:center">
                <el-col style="margin:40px auto 0px auto " >
                  <span style="font-size: 16px;font-family: SourceHanSansCN-Regular">暂无数据</span>
                </el-col>
              </el-row>
              <el-col style="width: 336px" v-for="system in zhengceSystem.list" :key="system.id">
                <el-card style="margin-top: 20px;margin-left: 20px">
                  <div slot="header" class="clearfix" style="width: 100%">
                    <el-button class="white" style="font-size: 16px;color: #045fb4;font-family: SourceHanSansCN-Regular"type="text" @click="openzhengceDetail(system.id, system.name)">{{ system.name }}</el-button>
                  </div>
                  <div style="width: 100%">
                    <div class="white">
                      <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">体系编码：</span>
                      <template >
                        <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">{{ system.code }}</span>
                      </template>
                    </div>
                    <div style="margin-top: 10px">
                      <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">发布时间：</span>
                      <template >
                        <span class="white" style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">{{ system.createTime.substring(0,10) }}</span>
                      </template>
                    </div>
                    <div style="margin-top: 10px">
                      <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">体系状态：</span>
                      <template >
                        <el-tag v-if="system.status=='1'" type="success">启用</el-tag>
                        <el-tag v-if="system.status=='0'" type="warning">停用</el-tag>
                      </template>
                    </div>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="机构体系" name="3">
            <el-row style="background-color: #FFFFFF;width: 1030px;min-height: 500px;">
              <el-row v-if="jigoutixi" style="text-align:center">
                <el-col style="margin:40px auto 0px auto " >
                  <span style="font-size: 16px;font-family: SourceHanSansCN-Regular">暂无数据</span>
                </el-col>
              </el-row>
              <el-col style="width: 336px"  v-for="system in jigouSystem.list" :key="system.id">
                <el-card style="margin-top: 20px;margin-left: 20px">
                  <div slot="header" class="clearfix" style="width: 100%">
                    <el-button class="white"style="font-size: 16px;color: #045fb4;font-family: SourceHanSansCN-Regular"type="text" @click="openjigouDetail(system.id, system.name)">{{ system.name }}</el-button>
                  </div>
                  <div style="width: 100%">
                    <div class="white">
                      <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">体系编码：</span>
                      <template >
                        <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">{{ system.code }}</span>
                      </template>
                    </div>
                    <div style="margin-top: 10px">
                      <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">发布时间：</span>
                      <template >
                        <span class="white" style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">{{ system.createTime.substring(0,10) }}</span>
                      </template>
                    </div>
                    <div style="margin-top: 10px">
                      <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">体系状态：</span>
                      <template >
                        <el-tag v-if="system.status=='1'" type="success">启用</el-tag>
                        <el-tag v-if="system.status=='0'" type="warning">停用</el-tag>
                      </template>
                    </div>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="资讯体系" name="4">
            <el-row  style="background-color: #FFFFFF;width: 1030px;min-height: 500px;">
              <el-row v-if="zixuntixi" style="text-align:center">
                <el-col style="margin:40px auto 0px auto " >
                  <span style="font-size: 16px;font-family: SourceHanSansCN-Regular">暂无数据</span>
                </el-col>
              </el-row>
              <el-col style="width: 336px"  v-for="system in zixunSystem.list" :key="system.id">
                <el-card style="margin-top: 20px;margin-left: 20px">
                  <div slot="header" class="clearfix" style="width: 100%">
                    <el-button class="white" style="font-size: 16px;color: #045fb4;font-family: SourceHanSansCN-Regular" type="text" @click="openzixunDetail(system.id, system.name)">{{ system.name }}</el-button>
                  </div>
                  <div style="width: 100%">
                    <div class="white">
                      <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">体系编码：</span>
                      <template >
                        <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">{{ system.code }}</span>
                      </template>
                    </div>
                    <div style="margin-top: 10px">
                      <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">发布时间：</span>
                      <template >
                        <span class="white" style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">{{ system.createTime.substring(0,10) }}</span>
                      </template>
                    </div>
                    <div style="margin-top: 10px">
                      <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">体系状态：</span>
                      <template >
                        <el-tag v-if="system.status=='1'" type="success">启用</el-tag>
                        <el-tag v-if="system.status=='0'" type="warning">停用</el-tag>
                      </template>
                    </div>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </el-tab-pane>-->
        </el-tabs>
      </el-col>
    </el-row>
    <el-row style="padding-top: 30px;background-color: #FFFFFF;margin-top: 10px" v-if="!showSystem" >
      <el-col >
        <div style="margin-left: 100px">
          <el-button type="text" style="font-size: 16px" @click="showSystem=true">返回体系</el-button>
        </div>
        <div id="myChart" style="width: 100%;height: 600px"></div>
      </el-col>
    </el-row>
    </div>
  </div>
</template>
<script>
import {getSystemId, getSystemName} from "../../utils/systemInfo";
import request from "../../utils/request";
import echarts from 'echarts'
import NavigationBar from "./compoment/navigationBar";

export default {
  name:'mapping',
  components: {NavigationBar},
  data(){
    return{
      biaozhuntixi:true,
      zhengcetixi:true,
      jigoutixi:true,
      zixuntixi:true,
      tabs: '1',
      showSystem:true,
      input: "",
      imageUrlTop:require('../../../static/image/home.jpg'),
      systemName:getSystemName(),
      dataList:[],
      zhengceList: [],
      jigouList: [],
      zixunList: [],
      belong:'',
      pageQuerySystem: {
        pageNumber: 1,
        pageSize: 20,
        name: '',
        orgName: '',
        belong: '',
        status:'1'
      },
      pageSystem: {
        pageNumber: 1,
        pageSize: 20,
        totalPage: 0,
        totalRow: 0,
        list: []
      },
      zhengceSystem: {
        pageNumber: 1,
        pageSize: 20,
        totalPage: 0,
        totalRow: 0,
        list: []
      },
      jigouSystem: {
        pageNumber: 1,
        pageSize: 20,
        totalPage: 0,
        totalRow: 0,
        list: []
      },
      zixunSystem: {
        pageNumber: 1,
        pageSize: 20,
        totalPage: 0,
        totalRow: 0,
        list: []
      },
    }
  },
  methods:{
    numCount(data) {
      // console.log('data', data)
      let dat = data.count != null ? data.count : 0

      if (data.children && data.children.length > 0) {
        dat += this.traversalObject(data.children, dat)
      }
      // console.log('datdatdatdat', dat)
      return dat
    },

    traversalObject(obj, dat) {
      let dataCount = 0
      const _this = this
      obj.forEach(function(item) {
        dataCount = dataCount + item.count
        if (item.children && item.children.length > 0) {
          dataCount += _this.traversalObject(item.children, dat)
        }
      })
      return dataCount
    },
    //打开标准体系
    openDetail(id){
      this.getTree(id);
      this.showSystem=false
    },
    //打开政策体系
    openzhengceDetail(id,name){
      this.getzhengceTree(id, name);
      this.showSystem=false
    },
    //打开机构体系
    openjigouDetail(id,name){
      this.getjigouTree(id,name);
      this.showSystem=false
    },
    //打开资讯体系
    openzixunDetail(id,name){
      this.getzixunTree(id,name);
      this.showSystem=false
    },
    /**
     * 标准体系列表
     */
    getSystemList(data){
      if (data) {
        this.pageQuerySystem.pageNumber = data.page
        this.pageQuerySystem.pageSize = data.limit
      }
      this.pageQuerySystem.belong=this.belong
      request.post('/portalController/querySystemList', this.pageQuerySystem).then(rsp => {
        if (rsp.resultCode === '0') {
          this.pageSystem = rsp.data
          this.biaozhuntixi = false
        } else {
          this.$message({
            type: 'error',
            message: '数据加载失败'
          })
        }
      })
    },
    //政策体系列表
    getzhengceList(data){
      if (data) {
        this.pageQuerySystem.pageNumber = data.page
        this.pageQuerySystem.pageSize = data.limit
      }
      this.pageQuerySystem.belong=this.belong
      request.post('/portalController/queryPolicySystemList', this.pageQuerySystem).then(rsp => {
        if (rsp.resultCode === '0') {
          this.zhengceSystem = rsp.data
          this.zhengcetixi = false
        } else {
          this.$message({
            type: 'error',
            message: '数据加载失败'
          })
        }
      })
    },
    //机构体系列表
    getjigouList(data){
      if (data) {
        this.pageQuerySystem.pageNumber = data.page
        this.pageQuerySystem.pageSize = data.limit
      }
      this.pageQuerySystem.belong=this.belong
      request.post('/portalController/queryOrgSystemList', this.pageQuerySystem).then(rsp => {
        if (rsp.resultCode === '0') {
          this.jigouSystem = rsp.data
          this.jigoutixi = false
        } else {
          this.$message({
            type: 'error',
            message: '数据加载失败'
          })
        }
      })
    },
    //资讯体系列表
    getzixunList(data){
      if (data) {
        this.pageQuerySystem.pageNumber = data.page
        this.pageQuerySystem.pageSize = data.limit
      }
      this.pageQuerySystem.belong=this.belong
      request.post('/portalController/queryInfoSystemList', this.pageQuerySystem).then(rsp => {
        if (rsp.resultCode === '0') {
          this.zixunSystem = rsp.data
          this.zixuntixi =false
        } else {
          this.$message({
            type: 'error',
            message: '数据加载失败'
          })
        }
      })
    },
    /**
     * 跳转标准查询页
     */
    toSearch() {
      this.$router.push({ path: "/standard", query: { input: this.input } });
    },
    //标准树
    getTree(id){
      request({
        url:'/portalController/queryTree',
        methods: 'get',
        params:{
          systemId:id
        }
      }).then(rsp=>{
        if(rsp.resultCode==='0'){
          this.dataList=rsp.data
        }else {
          this.$message({
            message:'请求数据错误',
            type:'error',
            duration:1500
          })
        }
        this.initMyCharts();
      })
    },
    //政策树
    getzhengceTree(id,name){
      request({
        url:'/portalController/queryPolicyTree',
        methods: 'get',
        params:{
          systemId:id
        }
      }).then(rsp=>{
        if(rsp.resultCode==='0'){
          // this.zhengceList=rsp.data
          this.zhengceList ={
            name: name,
            children: rsp.data
          }
        }else {
          this.$message({
            message:'请求数据错误',
            type:'error',
            duration:1500
          })
        }
        this.zhengceCharts();
      })
    },
    //机构树
    getjigouTree(id,name){
      request({
        url:'/portalController/queryOrgTree',
        methods: 'get',
        params:{
          systemId:id
        }
      }).then(rsp=>{
        if(rsp.resultCode==='0'){
          // this.jigouList=rsp.data
          this.jigouList = {
            name: name,
            children: rsp.data
          }
        }else {
          this.$message({
            message:'请求数据错误',
            type:'error',
            duration:1500
          })
        }
        this.jigouCharts();
      })
    },
    //资讯树
    getzixunTree(id,name){
      request({
        url:'/portalController/queryInfoTree',
        methods: 'get',
        params:{
          systemId:id
        }
      }).then(rsp=>{
        if(rsp.resultCode==='0'){
          // this.zixunList=rsp.data
          this.zixunList = {
            name: name,
            children: rsp.data
          }
        }else {
          this.$message({
            message:'请求数据错误',
            type:'error',
            duration:1500
          })
        }
        this.zixunCharts();
      })
    },
    //标准echarts
    initMyCharts(){
      let that=this
      let myChart = this.$echarts.init(document.getElementById('myChart'));
      myChart.setOption({
        title: {
          text: '标准体系映射视图',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          triggerOn: 'mousemove',
          enterable: true,
          formatter: function (info) {
            let countNum = that.numCount(info.data)
            if(countNum > 0){
              return [
                '映射标准数量: ' + echarts.format.addCommas(countNum)+'<br/>','<a href="./#/standardSystem?id='+info.data.id+'&type=biaozhun">点击查看标准</a>'
              ].join('');
            }else {
              return ['映射标准数量: ' + echarts.format.addCommas(countNum)+'<br/>'].join('');
            }
          }
        },
        series: [
          {
            type: 'tree',
            data: [that.dataList],
            top: '12%',
            left: '2%',
            bottom: '20%',
            right: '2%',
            symbolSize: 7,
            orient: 'vertical',
            expandAndCollapse: true,
            label: {
              position: 'top',
              verticalAlign: 'middle',
              align: 'left',
              fontSize: 13
            },
            leaves: {
              label: {
                position: 'bottom',
                verticalAlign: 'middle',
                align: 'left',
                rotate: -90,
              }
            },
            emphasis: {
              focus: 'descendant'
            },
            animationDuration: 550,
            animationDurationUpdate: 750
          }
        ]
      });
    },
    //政策echarts
    zhengceCharts(){
      let that=this
      let myChart = this.$echarts.init(document.getElementById('myChart'));
      myChart.setOption({
        title: {
          text: '政策体系映射视图',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          triggerOn: 'mousemove',
          enterable:true,
          formatter: function (info) {
            let countNum = that.numCount(info.data)
            if(countNum > 0){
              return [
                '映射政策数量: ' + echarts.format.addCommas(countNum)+'<br/>','<a href="./#/standardSystem?id='+info.data.id+'&type=zhengce">点击查看政策</a>'
              ].join('');
            }else {
              return [
                '映射政策数量: ' + echarts.format.addCommas(countNum)+'<br/>'
              ].join('');
            }
          }
        },
        series: [
          {
            type: 'tree',
            data: [that.zhengceList],
            top: '12%',
            left: '2%',
            bottom: '20%',
            right: '2%',
            symbolSize: 7,
            orient: 'vertical',
            label: {
              position: 'top',
              verticalAlign: 'middle',
              align: 'left',
              fontSize: 13
            },
            leaves: {
              label: {
                position: 'bottom',
                verticalAlign: 'middle',
                rotate: -90,
                align: 'left'
              }
            },
            emphasis: {
              focus: 'descendant'
            },
            expandAndCollapse: true,
            animationDuration: 550,
            animationDurationUpdate: 750
          }
        ]
      });
    },
    //机构echarts
    jigouCharts(){
      let that=this
      let myChart = this.$echarts.init(document.getElementById('myChart'));
      myChart.setOption({
        title: {
          text: '机构体系映射视图',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          triggerOn: 'mousemove',
          enterable:true,
          formatter: function (info) {
            let countNum = that.numCount(info.data)
            if(countNum > 0){
              return [
                '映射机构数量: ' + echarts.format.addCommas(countNum)+'<br/>','<a href="./#/standardSystem?id='+info.data.id+'&type=jigou">点击查看机构</a>'
              ].join('');
            }else {
              return [
                '映射机构数量: ' + echarts.format.addCommas(countNum)+'<br/>'
              ].join('');
            }
          }
        },
        series: [
          {
            type: 'tree',
            data: [that.jigouList],
            top: '12%',
            left: '2%',
            bottom: '20%',
            right: '2%',
            symbolSize: 7,
            orient: 'vertical',
            label: {
              position: 'top',
              verticalAlign: 'middle',
              align: 'left',
              fontSize: 13
            },
            leaves: {
              label: {
                position: 'bottom',
                verticalAlign: 'middle',
                rotate: -90,
                align: 'left'
              }
            },
            emphasis: {
              focus: 'descendant'
            },
            expandAndCollapse: true,
            animationDuration: 550,
            animationDurationUpdate: 750
          }
        ]
      });
    },
    //资讯echarts
    zixunCharts(){
      let that=this
      let myChart = this.$echarts.init(document.getElementById('myChart'));
      myChart.setOption({
        title: {
          text: '资讯体系映射视图',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          triggerOn: 'mousemove',
          enterable:true,
          formatter: function (info) {
            let countNum = that.numCount(info.data)
            if(countNum > 0){
              return [
                '映射资讯数量: ' + echarts.format.addCommas(countNum)+'<br/>','<a href="./#/standardSystem?id='+info.data.id+'&type=zixun">点击查看资讯</a>'
              ].join('');
            }else {
              return [
                '映射资讯数量: ' + echarts.format.addCommas(countNum)+'<br/>'
              ].join('');
            }
          }
        },
        series: [
          {
            type: 'tree',
            data: [that.zixunList],
            top: '12%',
            left: '2%',
            bottom: '20%',
            right: '2%',
            symbolSize: 7,
            orient: 'vertical',
            expandAndCollapse: true,
            label: {
              position: 'top',
              verticalAlign: 'middle',
              align: 'left',
              fontSize: 13
            },
            leaves: {
              label: {
                position: 'bottom',
                verticalAlign: 'middle',
                rotate: -90,
                align: 'left'
              }
            },
            emphasis: {
              focus: 'descendant'
            },
            animationDuration: 550,
            animationDurationUpdate: 750
          }
        ]
      });
    },
  },
  created(){
    this.belong=getSystemId();
  },
  mounted(){
    imageUrlTop: "/static/image/home.jpg",
    document.title = this.systemName
    /*this.getTree();*/
    this.getSystemList();
    this.getzixunList();
    this.getjigouList();
    this.getzhengceList()
  },
}
</script>
<style scoped>
.page1{
  background: url("../../../static/image/body-bg.jpg") no-repeat;
  height: 100%;
  width: 100%;
  background-size:100% 775px;
}
>>> .el-tabs__nav .el-tabs__item:hover {
  color: #ffffff;
  background-color: #004e96 ;
}
>>> .el-tabs__nav .el-tabs__item.is-active {
  color: #ffffff;
  background-color: #004e96;
}
>>> .el-tabs__nav .el-tabs__item {
  color: #000000;
  background-color: #FFFFFF;
}
</style>
<style>
.el-tabs__item.is-left{
  width: 150px;
  height: 55px;
  font-size: 16px;
  font-family: SourceHanSansCN-Regular;
  text-align: center !important;
  line-height: 55px;
}

.el-tabs__active-bar.is-left{
  width: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/home/mapping.vue